module.exports = __webpack_public_path__ + "media/images/application/barre-93f5b12659741394f6fd853133b40887.png";